import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_emgllltle6: FaireBrandEntity = {
  token: "b_emgllltle6",
  type: "brand",
  name: "Canvas Style",
  avatarUrl:
    "https://cdn.faire.com/fastly/e9404ef8d0256fcd0e04c494f06a071e6e453ec9a7c036acbc98a94a635868ef.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5e496426497de7ad7bb696638c87c82ab5c96fe56d7755721ea25125b83d505e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e9404ef8d0256fcd0e04c494f06a071e6e453ec9a7c036acbc98a94a635868ef.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5e496426497de7ad7bb696638c87c82ab5c96fe56d7755721ea25125b83d505e.jpeg",
  location: "San Antonio, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 721,
  isTopShop: true,
  isInsider: true,
  description:
    "Canvas Style is an on-trend fashion jewelry brand with a piece of jewelry for every event, occasion & destination. Each piece is designed in-house by husband & wife duo, Michelle & Davin Shaw, striking a balance between colorful & preppy designs, grandmillennial style, updated classics and on-trend looks, inspired by their extensive travels near & far, popular home décor trends and Michelle's love for entertaining.\n\nWe offer one of the most extensive fashion jewelry collections, adding hundreds of new items each season. With a diverse selection of products each season, our staple collections include Holidays (Christmas, Valentine's Day, Easter, 4th of July & more!), Occasions & Celebrations (Wedding, Derby, Game Day), Resort Chic & Signature Staples, Modern Pearls and Classic Metals PLUS our licensed collections of 45 NCAA teams, Kentucky Derby and Coca-Cola. \n\nWe believe women should be able to treat themselves with quality accessories that bring smiles to their faces, without feeling guilty about their purchases. That's why creating high-quality, easy-to-pair and wear jewelry at guilt-free price points is at the core of everything we do at Canvas Style. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:46.122Z",
    importedBy: "entity-db-cli",
  },
};
